import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/analytics";
import { pixelPageView } from "../utils/metaPixel";

export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
    pixelPageView();
  }, [location]);
}
